var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUniversity = function SvgUniversity(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none!important",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19 8H5a.333.333 0 0 1-.143-.635l7-3.333a.337.337 0 0 1 .286 0l7 3.333A.334.334 0 0 1 19 8zM5.39 10.185a.333.333 0 0 0 .277.148h12.666a.333.333 0 0 0 .278-.148l.666-1A.333.333 0 0 0 19 8.667H5a.333.333 0 0 0-.277.518l.666 1zM8.666 11H6v5.667h2.667V11zm9.59 6.453l1.666 2a.333.333 0 0 1-.256.547H4.333a.333.333 0 0 1-.256-.547l1.667-2a.333.333 0 0 1 .256-.12h12a.334.334 0 0 1 .256.12zM10.666 11h2.666v5.667h-2.666V11zM18 11h-2.667v5.667H18V11z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUniversity);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "university.ac41973fb5c9b933d64d1bdf99a3a12e.svg";